module.exports = __webpack_public_path__ + "media/assets/images/landings/contact_center/screens/ticket_timeline-c71cdaeb8732553bbe6e99650f3a7158.png";